<template>
  <div class="sd_info">
    <div class="sd_info__content">
      <div v-for="(item, item_key) in sd_info" :key="item_key" class="sd_info__content content-item" >
        <div class="left">
<!--          <span class="title">{{ item_key }}</span>-->
        </div>
        <div class="right">
          <span class="title">{{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "status",
  props: ['sd_info'],
}
</script>

<style lang="scss" scoped>
.sd_info{
  height: 500px;
  overflow-x: auto;
  padding: 2px;
  &::-webkit-scrollbar{
    width: 10px;
  }
  .sd_info {
    .card_title{
      display: block;
      cursor: pointer;
      text-align: center;
      padding: 5px;
      background-color: #efe9e9;
      border-bottom: 1px solid #ccc;
    }
    &__content {
      font: 300 12px/16px "Roboto", Arial, sans-serif;
      text-align: center;
      overflow: hidden;
      opacity: 1;
      transition: all 0.3s;
      &.hide_block{
        opacity: 0;
        height: 0;
      }
      .content-item{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 5px;
        &:nth-child(2n+1) {
          background-color: #e2ecdc;
        }
        .left{
          width: 40%;
        }
        .right{
          width: 60%;
        }
        div{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 12px;
          height: 100%;
          span{
            text-overflow: ellipsis;
          }
        }
      }
    }
    &_footer {
      text-align: center;
      padding: 15px 0 5px;
      border-top: 1px solid #ccc;
    }
  }
}

@media (max-width: 475px) {
  .modem_card {
    &_content {
      .content-item{
        flex-wrap: wrap;
        .left{
          width: 100%;
        }
        .right{
          width: 100%;
        }
      }
    }
  }
}


</style>
